import React, { useState } from "react";
import { successLogo } from "../../../assets/images";
import { formatAmount } from "../../../utils/formatTime";
import useAuthAxios from "../../../utils/baseAxios";
import { API } from "../../../constants/api";
import { useMutation } from "@tanstack/react-query";
import { errorMessage } from "../../../utils/errorMessage";
import toast from "react-hot-toast";
import { ClipLoader } from "react-spinners";
import SurveyCard from "../../../components/survey/SurveyCard";

const ExWSuccess = ({
  setOpenSuccess,
  amount,
  wallet,
  setOpenWithdrawExWallet,
  network,
  selectedCoinObjw,
  fee,
}: any) => {
  const [saveBeneficiary, setSaveBeneficiary] = useState<boolean>(false);
  const [beneficiaryName, setBeneficiaryName] = useState<string>("");
  const [beneficiaryNotes, setBeneficiaryNotes] = useState<string>("");

  const axiosInstance = useAuthAxios();

  const saveBeneficiaryApi = async (data: any) => {
    const response = await axiosInstance.post(API.saveBeneficiary, data);
    return response.data;
  };

  const completeSaveBeneficiary = useMutation({
    mutationFn: saveBeneficiaryApi,
    onSuccess: (r) => {
      toast.success(r.message);

      setTimeout(() => {
        setOpenSuccess(false);
        setOpenWithdrawExWallet(false);
      }, 2000);
    },
    onError: (e) => {
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        {/* <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
                setOpenSwapSuccess(true);
              setOpenSwapPreview(true);
            }}
            className="flex items-center gap-2 "
          >
            <SlArrowLeft className="dark:text-[#D8D8D8] text-gray-800 text-[12px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Preview Swap
          </h4>
        </div> */}
        {!saveBeneficiary && (
          <div className="w-full flex justify-center px-3 md:px-6 items-center flex-col gap-4">
            <div className="w-[116px] h-[116px]">
              <img
                src={successLogo}
                className="w-full h-full bg-cover"
                alt=""
              />
            </div>
            <h4 className="font-sora font-bold text-center text-gray-900 dark:text-gray-100 text-[24px]">
              Withdrawal complete
            </h4>
            <h4 className=" font-medium text-gray-500 dark:text-gray-400 text-center text-[14px]">
              You have successfully withdrawn {formatAmount(Math.max(0, Number(amount) - Number(fee)))}{" "}
              {selectedCoinObjw?.abbr} to <strong className="">{wallet}</strong>{" "}
              address from your DeeX {selectedCoinObjw?.abbr} Wallet.
            </h4>
          </div>
        )}
        <div
          className={
            saveBeneficiary
              ? "mt-4 w-full overflow-hidden transition-all duration-300 ease-out max-h-[800px] opacity-100 translate-y-0"
              : "mt-4 w-full overflow-hidden transition-all duration-300 ease-in max-h-0 opacity-0 -translate-y-1"
          }
          aria-hidden={!saveBeneficiary}
        >
          <div className="w-full">
            <h4 className="text-gray-900 dark:text-gray-100 font-sora font-bold text-[15px] mb-6">
              Save beneficiary
            </h4>

            {/* Address Field - Read Only */}
            <div className="mb-3">
              <label className="text-gray-500 dark:text-gray-400 text-[12px] font-semibold">
                Address
              </label>
              <div className="mt-1 pb-3 border-b border-gray-200 dark:border-gray-600">
                <p className="text-gray-800 dark:text-gray-100 text-[14px] font-semibold break-all">
                  {wallet?.slice(0, 20)}...{wallet?.slice(-20)}
                </p>
              </div>
            </div>

            {/* Coin Field - Read Only */}
            <div className="mb-3">
              <label className="text-gray-500 dark:text-gray-400 text-[12px] font-semibold">
                Coin
              </label>
              <div className="mt-1 pb-3 border-b border-gray-200 dark:border-gray-600">
                <p className="text-gray-800 dark:text-gray-100 text-[14px] font-semibold">
                  {selectedCoinObjw?.name || selectedCoinObjw?.abbr}
                </p>
              </div>
            </div>

            {/* Network Field - Read Only */}
            <div className="mb-3">
              <label className="text-gray-500 dark:text-gray-400 text-[12px] font-semibold">
                Network
              </label>
              <div className="mt-1 pb-3 border-b border-gray-200 dark:border-gray-600">
                <p className="text-gray-800 dark:text-gray-100 text-[14px] font-semibold">
                  {network?.toUpperCase() || "N/A"}
                </p>
              </div>
            </div>

            {/* Name Input Field */}
            <div className="mb-4">
              <label className="text-gray-700 dark:text-gray-300 text-[12px] font-semibold">
                Name
              </label>
              <div className="relative mt-2">
                <input
                  type="text"
                  value={beneficiaryName}
                  onChange={(e) => setBeneficiaryName(e.target.value)}
                  placeholder="Type Name Here"
                  className="w-full h-[48px] outline-none text-[13px] border border-gray-300 dark:border-gray-600 bg-[#F7F8F9] dark:bg-[#1F2B36] dark:text-gray-300 text-gray-700 px-4 pr-24 rounded-xl"
                />
              </div>
            </div>

            {/* Notes Field - Optional */}
            <div className="mb-6">
              <label className="text-gray-700 dark:text-gray-300 text-[13px] font-medium">
                Notes <span className="text-gray-400">(optional)</span>
              </label>
              <textarea
                value={beneficiaryNotes}
                onChange={(e) => setBeneficiaryNotes(e.target.value)}
                placeholder="Add a short note"
                className="w-full min-h-[80px] mt-2 outline-none text-[13px] border border-gray-300 dark:border-gray-600 bg-[#F7F8F9] dark:bg-[#1F2B36] dark:text-gray-300 text-gray-700 px-4 py-3 rounded-xl resize-none"
              />
            </div>

            {/* Save Button */}
            <button
              onClick={() => {
                const data = {
                  name: beneficiaryName,
                  notes: beneficiaryNotes,
                  crypto: {
                    address: wallet,
                    network: network.toUpperCase(),
                    currency: selectedCoinObjw.abbr,
                  },
                };
                completeSaveBeneficiary.mutate(data);
              }}
              disabled={
                !beneficiaryName.trim() || completeSaveBeneficiary.isPending
              }
              className={
                !beneficiaryName.trim()
                  ? "w-full h-[48px] flex justify-center items-center font-manrope mx-auto text-gray-200 rounded-xl bg-gray-400 dark:bg-[#8f9294]"
                  : "w-full h-[48px] flex justify-center items-center font-manrope mx-auto font-medium rounded-xl text-white bg-secondary_button"
              }
            >
              {completeSaveBeneficiary.isPending ? (
                <ClipLoader color="#ffffff" size={20} />
              ) : (
                "Save"
              )}
            </button>
          </div>
        </div>
        {!saveBeneficiary && (
          <div
            className="overflow-hidden transition-all duration-500 ease-out mt-24 opacity-100 translate-y-0 "
            aria-hidden={saveBeneficiary}
          >
            {/* Renders only when the admin gave the survey the TRANSACTION_SUCCESS
                placement; nothing shows otherwise. Sits inside the !saveBeneficiary
                block so it stays out of the way while the beneficiary form is open. */}
            <SurveyCard placement="TRANSACTION_SUCCESS" className="mb-6" />
            <button
              onClick={() => {
                setOpenSuccess(false);
                setOpenWithdrawExWallet(false);
              }}
              className=" bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-[8px]"
            >
              Done
            </button>
            <button
              onClick={() => {
                setSaveBeneficiary(!saveBeneficiary);
              }}
              className="mt-4 border-gray-200 dark:border-gray-700 px-4  border flex justify-between items-center text-gray-400 dark:text-gray-600 text-[15px] font-medium h-[48px] w-full rounded-[8px]"
            >
              Save Beneficiary?
              <span className="text-secondary_button text-[14px] font-semibold">
                Yes
              </span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExWSuccess;
